export const calculateFinalPrice = (basePrice, taxRate = 0.14975) => {
  if (!basePrice || basePrice <= 0)
    return { stripeFee: 0, taxes: 0, subtotal: 0, totalPrice: 0 };

  const taxes = basePrice * taxRate;
  const stripeFee = (basePrice + taxes) * 0.029 + 0.3;

  const subtotal = basePrice + stripeFee; // affiché au client (billet + frais)
  const totalPrice = basePrice + stripeFee + taxes; // montant réellement payé

  return {
    ticketPrice: basePrice,
    stripeFee,
    subtotal,
    taxes,
    totalPrice,
  };
};

export const calculateStripePrice = (basePrice) => {
  if (!basePrice || basePrice <= 0) return 0;
  const stripeFee = basePrice * 0.03 + 0.3;
  const total = basePrice + stripeFee;
  return total.toFixed(2);
};
